<template>
	<div>
		<StateBar class="w-25p" />
		<h2 class="fs-title text-center">Ingóság adatai</h2>
		<ValidationObserver ref="form" v-slot="{ invalid }">
			<form @submit.prevent="onSubmit">
				<CalcElements :elements="computedElements" />
			</form>
			<NavButtons :prevLink="prevLink" :nextLink="nextLink" @next="onSubmit" @prev="onPrev" />
		</ValidationObserver>
	</div>
</template>

<script>
import StateBar from '@/components/StateBar.vue';
import Movables from '@json/Movables.json';
import CalcElements from '@/components/CalcElements.vue';
import NavButtons from '@/components/NavButtons.vue';
import validation from '@/mixins/validation';
import Popup from '@/components/Popup.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
	mixins: [validation],
	async mounted() {
		await this.fetchMovableTypes();
	},
	data() {
		return {
			elements: Movables,
			prevLink: 'property-details',
			nextLink: 'contract-details',
		};
	},
	components: {
		StateBar,
		CalcElements,
		NavButtons,
		Popup,
	},
	computed: {
		...mapGetters(['getOutbuildings', 'getMovableTypes', 'getValuableSum']),
		computedElements() {
			let elements = {};
			const gridLabelAreas = ['c', 'd', 'e', 'f'];
			const gridAreas = ['g', 'h', 'i', 'j'];

			this.getMovableTypes.valuables.forEach((valuable, index) => {
				elements[`${valuable.name}-label`] = {
					type: 'label',
					inputClass: 'mb-15px text-center',
					wrapperClass: '',
					className: '',
					innerClass: '',
					label: valuable.name,
					wrapClass: `grid-${gridLabelAreas[index]}`,
				};

				elements[valuable.name] = {
					name: 'insurance_value',
					index,
					inputGroup: 'valuables',
					type: 'text',
					unit: 'Ft',
					rules: 'number_space|divisible_by_thousand',
					inputClass: 'mb-15px',
					wrapperClass: '',
					className: '',
					label: `${valuable.name} Érték`,
					inputmode: 'numeric',
					format: true,
					wrapClass: `grid-${gridAreas[index]}`,
				};
			});

			elements['sum'] = {
				type: 'sum',
				inputClass: 'mb-15px mt-12px text-center font-bold',
				wrapperClass: '',
				className: '',
				innerClass: '',
				label: 'Összesen:',
				wrapClass: `grid-k`,
				getter: 'getValuableSum',
			};

			this.elements.groupElements2.elements = { ...this.elements.groupElements2.elements, ...elements };
			return this.elements;
		},
	},
	methods: {
		...mapActions(['fetchMovableTypes']),
	},
};
</script>
